<div id="openExtendsBookingHotel" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h4 class="modal-title">Registrar cliente</h4> -->
        <h5 class="modal-title mt-0 ng-binding">Reserva hotel</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="form-group col-lg-4">
              <label>Seleccionar hotel<span class="required"></span>
                <div class="book__nrodoc m-l-25 f-s-11" *ngIf="hotelSelected != null">
                  <i class="fas fa-map-marker-alt"></i> {{hotelSelected.citietouristic.description}}
                </div>
              </label>
              <ng-container *ngIf="hotelSelected == null">
                <component-search-hotel [classSize]="'search-small'" (selectedHotelEvent)="selectedHotelSearch($event)"
                  class="w-100">
                </component-search-hotel>
              </ng-container>
              <ng-container *ngIf="hotelSelected != null">
                <input type="text" class="form-control" value="{{hotelSelected.tradename}}" disabled>
              </ng-container>
            </div>
            <div class="form-group col-lg-3">
              <label>Asignar habitación<span class="required"></span></label>
              <div class="input-group">
                <select class="form-control" id="bedroomSelected" [(ngModel)]="bedroomSelected"
                  [ngModelOptions]="{standalone: true}" [disabled]="hotelSelected == null">
                  <option *ngFor="let item of bedrooms" [value]="item.id">{{ item.description }}</option>
                </select>
                <div class="input-group-append" *ngIf="hotelSelected != null">
                  <a class="btn btn-info btn-sm text-white pointer" (click)="addRateBedroom()">Agregar <i
                      class="fas fa-arrow-down m-l-5"></i></a>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3">
              <label>Observaciones</label>
              <textarea rows="1" class="form-control form-control-sm" formControlName="observation"></textarea>
            </div>
            <div class="form-group col-lg-2">
              <label>.</label>
              <ng-container *ngIf="!isEdit">
                <button *ngIf="hotelSelected != null" class="btn btn-default btn-sm text-danger"
                  (click)="removeHotel()"><i class="far fa-trash-alt m-r-5"></i>Quitar</button>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 m-t-10 form__contentTbl">
              <div class="table-responsive">
                <table class="table mb-0 table-sm">
                  <thead class="thead-default">
                    <tr>
                      <th>Habitación</th>
                      <th class="text-center">N° PAX</th>
                      <th class="text-center">Cant. HAB <span class="required m-t-5"></span></th>
                      <th class="text-center">Check-in</th>
                      <th class="text-center">Check-out</th>
                      <th class="text-center">#Noches <span class="required m-t-5"></span></th>
                      <th>P. Corporativo <span class="required m-t-5"></span></th>
                      <th>-S/ Descuento</th>
                      <th>+S/ Adicional</th>
                      <th>observación</th>
                      <th>Deuda</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="detail_bedrooms.length == 0">
                      <tr>
                        <td colspan="4"><span>Debe seleccionar el hotel para poder agregar las habitaciones</span></td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="detail_bedrooms.length > 0">
                      <tr *ngFor="let item of detail_bedrooms; let index_ = index">
                        <td>
                          {{item.typebedroom}}
                          <p class="badge badge-success f-s-8 bold m-t-2 m-b-0" *ngIf="item.is_paid">Reporte Cuadre</p>
                        </td>
                        <td class="text-center">
                          <input type="text" id="detailbedrooms_guests{{index_}}" value="{{item.guests}}"
                            (keyup)="changeGuests($event.target, index_)" numeric onclick="click_input(this)"
                            class="form-control sale__input text-center" [disabled]="item.is_paid">
                        </td>
                        <td>
                          <input type="text" id="detailbedrooms_quantity{{index_}}" value="{{item.quantity}}"
                            [disabled]="item.is_paid" (keyup)="changeHotelsQuantity($event.target, index_)" numeric
                            onclick="click_input(this)" class="form-control sale__input text-center">
                        </td>
                        <td>
                          <input type="text" class="form-control sale__input text-center" [disabled]="item.is_paid"
                            id="date_checkin{{index_}}" value="{{item.date_checkin}}">
                        </td>
                        <td>
                          <input type="text" class="form-control sale__input text-center" [disabled]="item.is_paid"
                            id="date_checkout{{index_}}" value="{{item.date_checkout}}">
                        </td>

                        <td>
                          <input type="text" id="detailbedrooms_nights{{index_}}" disabled="true"
                            value="{{item.nights}}" class="form-control sale__input text-center">
                        </td>
                        <td>
                          <input type="text" id="detailbedrooms_price{{index_}}" value="{{item.price}}"
                            [disabled]="item.is_paid" (keyup)="changeHotelsPrice($event.target, index_)" numeric
                            decimals="2" onclick="click_input(this)" class="form-control sale__input text-right">
                        </td>
                        <td>
                          <input type="text" id="detailbedrooms_discount{{index_}}" value="{{item.discount}}"
                            [disabled]="item.is_paid" (keyup)="changeHotelsDiscount($event.target, index_)" numeric
                            decimals="2" onclick="click_input(this)"
                            class="form-control sale__input text-right text-danger">
                        </td>
                        <td>
                          <input type="text" id="detailbedrooms_additional{{index_}}" value="{{item.additional}}"
                            [disabled]="item.is_paid" (keyup)="changeHotelsAdditional($event.target, index_)" numeric
                            decimals="2" onclick="click_input(this)"
                            class="form-control sale__input text-right text-success">
                        </td>
                        <td>
                          <input type="text" class="form-control sale__input" id="detailbedrooms_observation{{index_}}"
                            (keyup)="changeHotelsObservation($event.target, index_)" value="{{item.observation}}" [disabled]="item.is_paid">
                        </td>
                        <td class="nowrap">
                          <span class="f-s-11 text-primary">{{toolsService.momeySol()}}{{item.subtotal}}</span>
                        </td>
                        <td>
                          <i class="far fa-trash-alt pointer f-s-15 text-danger" (click)="removeBedroom(index_)"
                            *ngIf="!item.is_paid"></i>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
              <div *ngIf="detail_bedrooms.length > 0" class="row justify-content-md-end m-t-15">
                <div class="form-group col-lg-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text bold">DEUDA TOTAL S/. <span class="required-table"></span></div>
                    </div>
                    <input type="text" class="form-control form-control-sm text-right bold" id="total_book"
                      disabled="true" ng-model="total_book" value="{{total_booking}}">
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
            (click)="close()">Cancelar</button>
          <button type="submit" class="btn btn-primary">
            Ingresar datos
            <i class="fas fa-arrow-right m-l-5"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

